// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, string } from 'prop-types'
import Header from './Header'
import Form from './Form'
import { useHandleCreateComment } from './hooks'

const ModalContainer = props => {
  const {
    createCallback,
    idRoot,
    initialValues,
    pathComment,
  } = props

  const handleSubmit = useHandleCreateComment(createCallback, pathComment)

  return (
    <>
      <Header idRoot={idRoot} />
      <Form
        initialValues={initialValues}
        onSubmit={handleSubmit} />
    </>
  )
}

ModalContainer.propTypes = {
  createCallback: func.isRequired,
  idRoot: string.isRequired,
  initialValues: object.isRequired,
  pathComment: bool,
}

export default ModalContainer
